import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; 
import './index.css';

import KeycloakService from "./services/KeycloakService";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById('root'));
const renderApp = () => {
    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    );
}

KeycloakService.initKeycloak(renderApp);
